export default __webpack_public_path__ + "static/media/CodeNext-Trial-ExtraBold.995bd73a.ttf";